
<template>
    <div>
        <!--MODAL*****************************************************************************************************************************************************-->

        <b-modal ref="my-modal" hide-footer title="Marcar como ERRO DE PAGAMENTO" class="alert-box" size="lg">
            <div class="d-block text-center">
                <b-alert show variant="danger" 
                    v-if="mesAnoSelecionado && pagamento.mes_referencia && pagamento.ano_referencia">
                    <p>
                        Atenção, isto reverterá  o pagamento do Beneficiário 
                        <b>{{ familia.nome_completo }}</b>, no mês 
                        {{ pagamento.mes_referencia + '/' + pagamento.ano_referencia }} para ERRO DE PAGAMENTO.
                    </p>
                </b-alert>
            </div>
            <b-row>
                <b-col>
                    <b-button class="btn btn-success" block @click.prevent="corrigirPagamento">
                        $ Corrigir Pagamento
                    </b-button>
                </b-col>
                <b-col>
                    <b-button class="btn btn-danger" block @click="toggleModal">
                        Cancelar
                    </b-button>
                </b-col>
            </b-row>


        </b-modal>
        <!--MODAL*****************************************************************************************************************************************************-->
        <b-row>
            <b-col md="12">
                <div class="mx-auto col-md-12">
                    <b-card header="Corrigir pagamento" header-tag="header" class="col-12 p-0 my-2">
                        <b-card-body>
                            <b-row>
                                <b-col>
                                    <b-form-group label="CPF do Requerente:">
                                        <TheMask class="ant-input form-control" v-model="pagamento.cpf_requerente"
                                            :mask="['###.###.###-##']" />
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <b-form-group label="Mês/Ano:">
                                        <b-form-input type="month" v-model="mesAnoSelecionado" locale="pt-BR">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col class="text-right">
                                    <b-button id="show-btn" class="btn btn-success" @click="obtemFamiliaNomeCompletoPorCpf">
                                        $ Corrigir Pagamento
                                    </b-button>
                                </b-col>
                            </b-row>
                        </b-card-body>
                    </b-card>
                </div>
            </b-col>
        </b-row>

    </div>


</template>

<script>
import { TheMask } from 'vue-the-mask';
import Parametro from "../../../models/Parametro";
export default {
    components: { TheMask },
    data() {
        return {
            parametro: new Parametro(),
            mesAnoSelecionado: null,
            pagamento: {
                mes_referencia: null,
                ano_referencia: null,
                cpf_requerente: null,
            },
            familia: ''
        };
    },
    methods: {
        corrigirPagamento() {
            this.$api.post('pagamentos/configurar-pagamento',
                {
                    pagamento: this.pagamento
                })
                .then(response => {
                    if (response.status === 200) {
                        this.clearFields();
                        this.$helpers.showToast(this, 'Sucesso', response.data.message, 'success');
                        // this.$helpers.showToast(this, 'Sucesso', response.data, 'success');
                        console.log(response.data);
                        // this.$router.push("/admin/relatorios/pagamentos-consolidados" + this.parametro.id);
                        //this.start();
                    }
                })
                .catch(error => {
                    if (error.response.data) {
                        this.$helpers.showToast(this, 'Erro', error.response.data.message, 'danger');
                    }
                });

            this.hideModal();
        },
        clearFields() {
            this.parametro = new Parametro();
            this.mesAnoSelecionado = null;
            this.pagamento = {
                mes_referencia: null,
                ano_referencia: null,
                cpf_requerente: null,
            };
        },
        obtemFamiliaNomeCompletoPorCpf() {
            /*****************************TESTES DE VALIDAÇÃO DOS CAMPOS************************** */
            if (this.pagamento.cpf_requerente == null ||
                this.pagamento.cpf_requerente == ''
             ) {
                this.$helpers.showToast(this, 'Erro', 'CPF do Requerente não informado', 'danger');
                return;
            }
            if (this.mesAnoSelecionado == null ||
                this.mesAnoSelecionado == ''
            ) {
                this.$helpers.showToast(this, 'Erro', 'Mês/Ano não informado', 'danger');
                return;
            }
            if(this.mesAnoSelecionado.split('-')[1] == null ||
                this.mesAnoSelecionado.split('-')[1] == ''
            ) {
                this.$helpers.showToast(this, 'Erro', 'Mês não informado', 'danger');
                return;
            }
            if(this.mesAnoSelecionado.split('-')[0] == null ||
                this.mesAnoSelecionado.split('-')[0] == ''
            ) {
                this.$helpers.showToast(this, 'Erro', 'Ano não informado', 'danger');
                return;
            }
            /*****************************TESTES DE VALIDAÇÃO DOS CAMPOS************************** */
            this.$api.post('familias/obtem-familia-nome-completo-por-cpf',
                {
                    cpf_requerente: this.pagamento.cpf_requerente
                })
                .then(response => {
                    if (response.status === 200) {
                        this.pagamento.mes_referencia = this.mesAnoSelecionado.split('-')[1];
                        this.pagamento.ano_referencia = this.mesAnoSelecionado.split('-')[0];

                        this.familia = response.data;
                        this.showModal();
                    }
                })
                .catch(error => {
                    if (error.response.data) {
                        this.$helpers.showToast(this, 'Erro', error.response.data.message, 'danger');
                    }
                });
            console.log('Família: ' + this.familia.nome_completo);
        },
        /**COMANDOS MODAL********************************************************************************************************************* */
        showModal() {
            this.$refs['my-modal'].show()
        },
        hideModal() {
            this.$refs['my-modal'].hide()
        },
        toggleModal() {
            // We pass the ID of the button that we want to return focus to
            // when the modal has hidden
            this.$refs['my-modal'].toggle('#toggle-btn')
        }
        /**COMANDOS MODAL********************************************************************************************************************* */
    },
}


</script>

<style>
    .alert-box{
        color: #ffffff;
        background-color: #ff0000;
    }
</style>